<div class="create-order-page">
  <h3 class="mb-4">{{ pageTitle }}</h3>
  @if (createOrderError) {
    <app-error-alert
      class="create-order-error d-block mb-4"
      aria-live="assertive"
      tabindex="-1"
      [message]="createOrderError">
    </app-error-alert>
  }

  @if (loadingOrder) {
    <app-loading-spinner></app-loading-spinner>
  }

  <div
    class="create-order-content"
    [class.create-order-content-disabled]="!canInteractWithOrder"
    [attr.inert]="canInteractWithOrder ? null : ''"
    [attr.aria-busy]="loadingOrder">

  <div class="top-form-grid mb-5">
    <div class="left-fields">
      <div class="form-group">
        <label class="form-label" for="createOrderPatient">Пациент</label>
        <input id="createOrderPatient" type="text" class="form-control" [(ngModel)]="createOrderForm.patientName">
      </div>

      <div class="form-group">
        <label class="form-label" for="createOrderToothColor">Боја</label>
        <select id="createOrderToothColor" class="form-select" [(ngModel)]="createOrderForm.toothColor">
          <option [ngValue]="null"></option>
          @for (option of toothColorOptions; track option.value) {
            <option [ngValue]="option.value">{{ option.label }}</option>
          }
        </select>
      </div>
    </div>

    <div class="form-group description-field">
      <label class="form-label" for="createOrderDescription">Опис</label>
      <textarea id="createOrderDescription" class="form-control" [(ngModel)]="createOrderForm.description"></textarea>
    </div>
  </div>

  <div class="mt-5">
    <div class="card border-0 bg-light rounded-3 mb-3">
      <div class="card-body p-3 d-flex flex-wrap align-items-center gap-2 gap-sm-3">
        <h4 class="h6 text-secondary text-nowrap mb-0">Активна изработка</h4>
        <span class="active-product-badge badge bg-white text-dark border rounded-pill px-3 py-2 d-inline-flex align-items-center gap-2 overflow-hidden">
          @if (currentProduct) {
            <fa-icon class="flex-shrink-0" [ngStyle]="{color: currentProduct.color}" [icon]="faTooth"></fa-icon>
          }
          <strong class="active-product-name text-truncate">{{ activeProductName }}</strong>
        </span>
      </div>
    </div>

    <div class="row g-3 align-items-stretch mb-5">
      <div class="col-12 col-lg-auto order-2 order-lg-1 d-flex align-items-center justify-content-center">
        <div class="card border-0 bg-light rounded-3 w-100">
          <div class="card-body p-2 d-flex flex-row flex-wrap flex-lg-column align-items-center justify-content-center justify-content-lg-start gap-2 order-editor-tools" role="toolbar" aria-label="Алатки за изработката">
                <span
                  class="d-inline-block"
                  [attr.tabindex]="!canUndo ? 0 : null"
                  matTooltip="Врати промена (Ctrl+Z)"
                  matTooltipPosition="above"
                  aria-label="Врати промена (Ctrl+Z)">
                  <button
                    type="button"
                    class="btn app-btn-soft app-btn-square"
                    [class.pe-none]="!canUndo"
                    [disabled]="!canUndo"
                    (click)="undo()"
                    aria-label="Врати ја последната промена"
                    aria-keyshortcuts="Control+Z Meta+Z">
                    <fa-icon [fixedWidth]="true" [icon]="faRotateLeft"></fa-icon>
                  </button>
                </span>
                <span
                  class="d-inline-block"
                  [attr.tabindex]="!canRedo ? 0 : null"
                  matTooltip="Повтори промена (Ctrl+Y)"
                  matTooltipPosition="above"
                  aria-label="Повтори промена (Ctrl+Y)">
                  <button
                    type="button"
                    class="btn app-btn-soft app-btn-square"
                    [class.pe-none]="!canRedo"
                    [disabled]="!canRedo"
                    (click)="redo()"
                    aria-label="Повтори ја последната вратена промена"
                    aria-keyshortcuts="Control+Y Control+Shift+Z Meta+Shift+Z">
                    <fa-icon [fixedWidth]="true" [icon]="faRotateRight"></fa-icon>
                  </button>
                </span>
                <span
                  class="d-inline-block"
                  matTooltip="Одбери изработка"
                  matTooltipPosition="above"
                  aria-label="Одбери изработка">
                  <button
                    type="button"
                    class="btn app-btn-soft app-btn-square mode-button"
                    [class.is-active]="selectionMode === 'choose'"
                    [attr.aria-pressed]="selectionMode === 'choose'"
                    (click)="setSelectionMode('choose')"
                    aria-label="Одбери изработка">
                    <fa-icon [fixedWidth]="true" [icon]="faTooth"></fa-icon>
                  </button>
                </span>
                <span
                  class="d-inline-block"
                  [attr.tabindex]="!currentProduct ? 0 : null"
                  matTooltip="Нацртај еден заб (Ctrl)"
                  matTooltipPosition="above"
                  aria-label="Нацртај еден заб (Ctrl)">
                  <button
                    type="button"
                    class="btn app-btn-soft app-btn-square mode-button"
                    [class.is-active]="selectionMode === 'single'"
                    [class.pe-none]="!currentProduct"
                    [attr.aria-pressed]="selectionMode === 'single'"
                    [disabled]="!currentProduct"
                    (click)="setSelectionMode('single')"
                    aria-label="Нацртај еден заб (Ctrl)">
                    <fa-icon [fixedWidth]="true" [icon]="faBullseye"></fa-icon>
                  </button>
                </span>
                <span
                  class="d-inline-block"
                  [attr.tabindex]="!currentProduct ? 0 : null"
                  matTooltip="Нацртај повеќе заби (Shift)"
                  matTooltipPosition="above"
                  aria-label="Нацртај повеќе заби (Shift)">
                  <button
                    type="button"
                    class="btn app-btn-soft app-btn-square mode-button"
                    [class.is-active]="selectionMode === 'range'"
                    [class.pe-none]="!currentProduct"
                    [attr.aria-pressed]="selectionMode === 'range'"
                    [disabled]="!currentProduct"
                    (click)="setSelectionMode('range')"
                    aria-label="Нацртај повеќе заби (Shift)">
                    <fa-icon [fixedWidth]="true" [icon]="faArrowsLeftRight"></fa-icon>
                  </button>
                </span>
                <span
                  class="d-inline-block"
                  matTooltip="Исчисти заб"
                  matTooltipPosition="above"
                  aria-label="Исчисти заб">
                  <button
                    type="button"
                    class="btn app-btn-soft app-btn-square mode-button"
                    [class.is-active]="selectionMode === 'clear'"
                    [attr.aria-pressed]="selectionMode === 'clear'"
                    (click)="setSelectionMode('clear')"
                    aria-label="Исчисти заб">
                    <fa-icon [fixedWidth]="true" [icon]="faEraser"></fa-icon>
                  </button>
                </span>
                <span
                  class="d-inline-block"
                  [attr.tabindex]="!selectedProducts.length ? 0 : null"
                  matTooltip="Исчисти се"
                  matTooltipPosition="above"
                  aria-label="Исчисти се">
                  <button
                    type="button"
                    class="btn btn-outline-danger app-btn-square rounded-3"
                    [class.pe-none]="!selectedProducts.length"
                    [disabled]="!selectedProducts.length"
                    (click)="clearEverything()"
                    aria-label="Исчисти се">
                    <fa-icon [fixedWidth]="true" [icon]="faBroom"></fa-icon>
                  </button>
                </span>
                <button
                  type="button"
                  class="btn app-btn-soft app-btn-square d-none d-lg-inline-block"
                  data-bs-toggle="popover"
                  data-order-shortcuts-popover
                  data-bs-trigger="focus"
                  data-bs-placement="auto"
                  data-bs-html="true"
                  data-bs-title="Кратенки за работа"
                  data-bs-content="<div class='order-shortcuts-list' role='list'><div class='order-shortcuts-item d-flex flex-wrap' role='listitem'><span class='order-shortcuts-keys'><span class='order-shortcuts-key-group'><span class='order-shortcuts-key'>Ctrl</span><span class='order-shortcuts-separator' aria-hidden='true'>/</span><span class='order-shortcuts-key'>Cmd</span><span class='order-shortcuts-separator' aria-hidden='true'>+</span><span class='order-shortcuts-key'>Z</span></span></span><span class='order-shortcuts-description'>Врати промена.</span></div><div class='order-shortcuts-item d-flex flex-wrap' role='listitem'><span class='order-shortcuts-keys'><span class='order-shortcuts-key-group'><span class='order-shortcuts-key'>Ctrl</span><span class='order-shortcuts-separator' aria-hidden='true'>/</span><span class='order-shortcuts-key'>Cmd</span><span class='order-shortcuts-separator' aria-hidden='true'>+</span><span class='order-shortcuts-key'>Y</span></span><span class='order-shortcuts-or'>или</span><span class='order-shortcuts-key-group'><span class='order-shortcuts-key'>Ctrl</span><span class='order-shortcuts-separator' aria-hidden='true'>/</span><span class='order-shortcuts-key'>Cmd</span><span class='order-shortcuts-separator' aria-hidden='true'>+</span><span class='order-shortcuts-key'>Shift</span><span class='order-shortcuts-separator' aria-hidden='true'>+</span><span class='order-shortcuts-key'>Z</span></span></span><span class='order-shortcuts-description'>Повтори промена.</span></div><div class='order-shortcuts-item d-flex flex-wrap' role='listitem'><span class='order-shortcuts-keys'><span class='order-shortcuts-key-group'><span class='order-shortcuts-key'>Ctrl</span><span class='order-shortcuts-separator' aria-hidden='true'>+</span><span class='order-shortcuts-key'>клик</span></span></span><span class='order-shortcuts-description'>Нанеси ја активната изработка на еден заб.</span></div><div class='order-shortcuts-item d-flex flex-wrap' role='listitem'><span class='order-shortcuts-keys'><span class='order-shortcuts-key-group'><span class='order-shortcuts-key'>Shift</span><span class='order-shortcuts-separator' aria-hidden='true'>+</span><span class='order-shortcuts-key'>клик</span></span></span><span class='order-shortcuts-description'>Нанеси ја активната изработка од претходниот до избраниот заб.</span></div><div class='order-shortcuts-item d-flex flex-wrap' role='listitem'><span class='order-shortcuts-keys'><span class='order-shortcuts-key'>Среден клик</span></span><span class='order-shortcuts-description'>Исчисти го забот.</span></div></div>"
                  aria-label="Прикажи ги кратенките за работа">
                  <fa-icon [fixedWidth]="true" [icon]="faCircleQuestion"></fa-icon>
                </button>
          </div>
        </div>
      </div>

        <div class="col-12 col-lg order-1 order-lg-2 d-flex align-items-center justify-content-center py-3">
          <div class="create-order-arches text-center w-100">
            <app-dental-arches
              [products]="selectedDentalProducts"
              [selectable]="true"
              (toothSelected)="handleToothSelected($event)">
            </app-dental-arches>
          </div>
        </div>

        <div class="col-12 col-lg order-3 order-lg-3">
          <div class="create-order-details-panel bg-light w-100 h-100 p-3 py-4 text-start">
            <div class="d-flex flex-wrap align-items-center justify-content-between gap-2 mb-3">
              <h5 class="mb-0">Детали</h5>
              <button
                type="button"
                class="btn primary-btn rounded-3 d-inline-flex align-items-center gap-2"
                (click)="openFullConstructionPicker()">
                <fa-icon [icon]="faPlus"></fa-icon>
                Целосни изработки
              </button>
            </div>

            @if (selectedProducts.length > 0) {
              <div class="selected-products-list">
                @for (product of selectedProducts; track product.id + '-' + product.isFullConstruction) {
                  <div class="selected-product-row" [class.selected]="isPaintingProduct(product)">
                    <div class="selected-product-content">
                      <div class="selected-product-main">
                        <fa-icon [ngStyle]="{color: product.color}" [fixedWidth]="true" [icon]="faTooth"></fa-icon>
                        <span class="selected-product-name">{{ product.name }}</span>
                      </div>
                      @if (isPaintingProduct(product)) {
                        <div class="selected-product-warning">
                          <fa-icon [icon]="faTriangleExclamation"></fa-icon>
                          Дали треба да ја прилагодите количината?
                        </div>
                      }
                    </div>

                    <div class="selected-product-actions ps-0 ps-sm-3">
                      @if (product.isFullConstruction) {
                        <button type="button" class="btn icon-action-button paint-action-button" [class.selected]="isPaintingProduct(product)" (click)="toggleFullConstructionPainting(product)" matTooltip="Одбери или исклучи цртање" matTooltipPosition="above" aria-label="Одбери или исклучи цртање">
                          <fa-icon [icon]="faPaintBrush"></fa-icon>
                        </button>
                        <button type="button" class="btn icon-action-button" (click)="incrementSelectedProduct(product)" matTooltip="Зголеми количина" matTooltipPosition="above" aria-label="Зголеми">
                          <fa-icon [icon]="faChevronUp"></fa-icon>
                        </button>
                        <button type="button" class="btn icon-action-button" (click)="decrementSelectedProduct(product)" matTooltip="Намали количина" matTooltipPosition="above" aria-label="Намали">
                          <fa-icon [icon]="faChevronDown"></fa-icon>
                        </button>
                      }
                      <span class="badge rounded-pill primary-bg mx-3">{{ product.quantity }}</span>
                      <button type="button" class="btn icon-action-button icon-action-danger" (click)="removeSelectedProduct(product)" matTooltip="Избриши изработка" matTooltipPosition="above" aria-label="Избриши">
                        <fa-icon [icon]="faTrash"></fa-icon>
                      </button>
                    </div>
                  </div>
                }
              </div>
            } @else {
              <app-no-items-found text="Нема одбрани изработки."></app-no-items-found>
            }

          </div>
        </div>
    </div>
  </div>

  <div class="files-section mb-4">
    <div class="d-flex align-items-center justify-content-between mb-2 gap-3">
      <h4 class="mb-0">Датотеки</h4>
      <button
        type="button"
        class="btn primary-btn rounded-3 mb-0 d-inline-flex align-items-center gap-2"
        (click)="openFilePicker()">
        <fa-icon [icon]="faUpload"></fa-icon>
        Прикачи датотека
      </button>
    </div>

    @if (existingFiles.length > 0 || selectedFiles.length > 0) {
      <div class="table-responsive w-100 app-table-card order-files-table-wrapper" role="region" aria-label="Датотеки на налогот" tabindex="0">
        <table class="table table-hover mb-0 align-middle app-data-table order-files-table">
          <thead>
            <tr>
              <th scope="col">Име</th>
              <th scope="col" class="d-none d-lg-table-cell">Опис</th>
              <th scope="col" class="d-none d-md-table-cell">Големина</th>
              <th scope="col" class="d-none d-md-table-cell">Датум</th>
              <th scope="col" class="text-center order-file-action-column">
                <span class="d-none d-md-inline">Акција</span>
                <span class="visually-hidden d-md-none">Акција</span>
              </th>
            </tr>
          </thead>
          <tbody>
            @for (file of existingFiles; track file.id) {
              <tr>
                <td class="text-start">
                  <span class="fw-semibold order-file-name">{{ file.fileName || file.name }}</span>
                  @if (file.description) {
                    <div class="d-lg-none small text-muted text-break mt-1">{{ file.description }}</div>
                  }
                  <div class="d-md-none small text-muted mt-1">
                    {{ formatBytes(file.sizeInBytes) }} <span aria-hidden="true">&middot;</span> {{ file.dateAdded | appDate:'date':formatting.formats() }}
                  </div>
                </td>
                <td class="d-none d-lg-table-cell text-break">
                  {{ file.description }}
                </td>
                <td class="d-none d-md-table-cell text-nowrap">{{ formatBytes(file.sizeInBytes) }}</td>
                <td class="d-none d-md-table-cell text-muted text-nowrap">{{ file.dateAdded | appDate:'date':formatting.formats() }}</td>
                <td class="text-center order-file-action-column">
                  <button
                    type="button"
                    class="btn primary-outline-btn rounded-3 d-inline-flex align-items-center gap-2 order-file-action-button"
                    [disabled]="isDownloading(file.id)"
                    [attr.aria-label]="'Преземи ја датотеката ' + (file.fileName || file.name || '')"
                    (click)="downloadFile(file)">
                    @if (isDownloading(file.id)) {
                      <span class="spinner-border spinner-border-sm" aria-hidden="true"></span>
                      <span class="d-none d-md-inline">Преземање</span>
                    } @else {
                      <fa-icon [icon]="faDownload"></fa-icon>
                      <span class="d-none d-md-inline">Преземи</span>
                    }
                  </button>
                </td>
              </tr>
            }
            @for (fileUpload of selectedFiles; track fileUpload.file.name + fileUpload.file.size + fileUpload.file.lastModified; let index = $index) {
              <tr>
                <td class="text-start">
                  <span class="fw-semibold order-file-name">{{ fileUpload.file.name }}</span>
                  @if (fileUpload.description) {
                    <div class="d-lg-none small text-muted text-break mt-1">{{ fileUpload.description }}</div>
                  }
                  <div class="d-md-none small text-muted mt-1">{{ formatBytes(fileUpload.file.size) }}</div>
                </td>
                <td class="d-none d-lg-table-cell text-break">
                  {{ fileUpload.description }}
                </td>
                <td class="d-none d-md-table-cell text-nowrap">{{ formatBytes(fileUpload.file.size) }}</td>
                <td class="d-none d-md-table-cell text-muted">-</td>
                <td class="text-center order-file-action-column">
                  <button
                    type="button"
                    class="btn btn-sm btn-outline-danger rounded-3 d-inline-flex align-items-center gap-2 order-file-action-button"
                    [attr.aria-label]="'Отстрани ја датотеката ' + fileUpload.file.name"
                    (click)="removeFile(index)">
                    <fa-icon [icon]="faTrash"></fa-icon>
                    <span class="d-none d-md-inline">Отстрани</span>
                  </button>
                </td>
              </tr>
            }
          </tbody>
        </table>
      </div>
    } @else {
      <app-no-items-found text="Нема прикачени датотеки."></app-no-items-found>
    }
  </div>

  <div class="d-flex justify-content-between align-items-center gap-3 flex-wrap mt-5">
    <a routerLink="/orders" class="btn app-btn-soft fw-bold px-3 d-inline-flex align-items-center gap-2">
      <fa-icon [icon]="faArrowLeft"></fa-icon>
      Назад
    </a>
    <button type="button" class="btn primary-btn rounded-3 d-inline-flex align-items-center gap-2" [disabled]="creatingOrder || !canInteractWithOrder" (click)="submitCreateOrder()">
      @if (creatingOrder) {
        <span class="spinner-border spinner-border-sm" aria-hidden="true"></span>
      } @else {
        <fa-icon [icon]="faFloppyDisk"></fa-icon>
      }
      Зачувај
    </button>
  </div>
  </div>
</div>

<div class="modal fade" id="createOrderFileModal" tabindex="-1" aria-labelledby="createOrderFileModalLabel" aria-hidden="true">
  <div class="modal-dialog modal-lg modal-dialog-centered">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title" id="createOrderFileModalLabel">Прикачи датотека</h5>
        <button type="button" class="btn-close" aria-label="Затвори" (click)="hideFilePicker()"></button>
      </div>
      <div class="modal-body p-4">
        <app-create-files
          [inModal]="true"
          [deferUpload]="true"
          (fileSelected)="handleStagedFileSelected($event)"
          (cancelled)="hideFilePicker()">
        </app-create-files>
      </div>
    </div>
  </div>
</div>

<div class="modal fade" id="createOrderProductModal" tabindex="-1" aria-labelledby="createOrderProductModalLabel" aria-hidden="true">
  <div class="modal-dialog modal-lg modal-dialog-centered modal-dialog-scrollable">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title d-flex align-items-center gap-2" id="createOrderProductModalLabel">
          <fa-icon [icon]="faTooth"></fa-icon>
          Одбери изработка
        </h5>
        <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Затвори"></button>
      </div>
      <div class="modal-body p-4">
        @if (loadingProducts) {
          <app-loading-spinner></app-loading-spinner>
        } @else if (regularProductGroups.length > 0) {
          <div class="product-category-stack">
            @for (group of regularProductGroups; track group.name) {
              <details class="product-category-panel" open>
                <summary class="product-category-summary">
                  <span class="product-category-heading">
                    <span class="product-category-color" [style.background-color]="group.color"></span>
                    <span class="product-category-name">{{ group.name }}</span>
                  </span>
                  <span class="product-category-meta">
                    <span class="badge rounded-pill bg-light text-secondary border">{{ group.products.length }}</span>
                    <fa-icon class="product-category-chevron" [icon]="faChevronDown"></fa-icon>
                  </span>
                </summary>
                <div class="product-category-body">
                  <div class="product-picker-grid">
                    @for (product of group.products; track product.id) {
                      <button
                        type="button"
                        class="btn product-picker-button"
                        [class.selected]="isProductSelectedForCurrentTooth(product)"
                        [attr.aria-pressed]="isProductSelectedForCurrentTooth(product)"
                        [style.border-left-color]="product.color || group.color"
                        (click)="selectProductForCurrentTooth(product)">
                        <span class="product-picker-main">
                          <fa-icon class="product-picker-tooth" [ngStyle]="{color: product.color || group.color}" [icon]="faTooth"></fa-icon>
                          <span class="product-picker-name">{{ product.name }}</span>
                        </span>
                        <fa-icon
                          class="product-picker-action"
                          [icon]="isProductSelectedForCurrentTooth(product) ? faCheck : faPlus">
                        </fa-icon>
                      </button>
                    }
                  </div>
                </div>
              </details>
            }
          </div>
        } @else {
          <app-no-items-found text="Нема изработки достапни за клиентската апликација."></app-no-items-found>
        }
      </div>
      <div class="modal-footer">
        @if (currentTooth != null) {
          <button type="button" class="btn primary-outline-btn rounded-3 d-inline-flex align-items-center gap-2 fw-semibold" (click)="clearCurrentToothFromModal()">
            <fa-icon [icon]="faEraser"></fa-icon>
            Без изработка
          </button>
        }
        <button type="button" class="btn app-btn-soft fw-bold px-3 d-inline-flex align-items-center gap-2" data-bs-dismiss="modal">
          <fa-icon [icon]="faXmark"></fa-icon>
          Затвори
        </button>
      </div>
    </div>
  </div>
</div>

<div class="modal fade" id="createOrderFullConstructionModal" tabindex="-1" aria-labelledby="createOrderFullConstructionModalLabel" aria-hidden="true">
  <div class="modal-dialog modal-lg modal-dialog-centered modal-dialog-scrollable">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title d-flex align-items-center gap-2" id="createOrderFullConstructionModalLabel">
          <fa-icon [icon]="faLayerGroup"></fa-icon>
          Одбери изработка
        </h5>
        <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Затвори"></button>
      </div>
      <div class="modal-body p-4">
        @if (loadingProducts) {
          <app-loading-spinner></app-loading-spinner>
        } @else if (fullConstructionProductGroups.length > 0) {
          <div class="product-category-stack">
            @for (group of fullConstructionProductGroups; track group.name) {
              <details class="product-category-panel" open>
                <summary class="product-category-summary">
                  <span class="product-category-heading">
                    <span class="product-category-color" [style.background-color]="group.color"></span>
                    <span class="product-category-name">{{ group.name }}</span>
                  </span>
                  <span class="product-category-meta">
                    <span class="badge rounded-pill bg-light text-secondary border">{{ group.products.length }}</span>
                    <fa-icon class="product-category-chevron" [icon]="faChevronDown"></fa-icon>
                  </span>
                </summary>
                <div class="product-category-body">
                  <div class="product-picker-grid">
                    @for (product of group.products; track product.id) {
                      <button
                        type="button"
                        class="btn product-picker-button"
                        [class.selected]="isFullConstructionSelected(product)"
                        [attr.aria-pressed]="isFullConstructionSelected(product)"
                        [style.border-left-color]="product.color || group.color"
                        (click)="addFullConstruction(product)">
                        <span class="product-picker-main">
                          <fa-icon class="product-picker-tooth" [ngStyle]="{color: product.color || group.color}" [icon]="faLayerGroup"></fa-icon>
                          <span class="product-picker-name">{{ product.name }}</span>
                        </span>
                        <fa-icon
                          class="product-picker-action"
                          [icon]="isFullConstructionSelected(product) ? faCheck : faPlus">
                        </fa-icon>
                      </button>
                    }
                  </div>
                </div>
              </details>
            }
          </div>
        } @else {
          <app-no-items-found text="Нема достапни целосни изработки."></app-no-items-found>
        }
      </div>
      <div class="modal-footer">
        <button type="button" class="btn app-btn-soft fw-bold px-3 d-inline-flex align-items-center gap-2" data-bs-dismiss="modal">
          <fa-icon [icon]="faXmark"></fa-icon>
          Затвори
        </button>
      </div>
    </div>
  </div>
</div>
